import $ from 'jquery';
import angular from 'angular';

/**
 * backTopDecorator decorates back to top directive from BlurAdmin.
 * It serves more educational purpose than practical (yes, it would be easier to create new directive instad).
 * Note that when decorating directive you are provided with an array of directive definitions, because there may
 * be more than one directive with the same name.
 *
 * @memberof BlurAdmin
 * @param {Array} $delegate all definitions matching "backTopDirective"
 * @param {Window} $window
 * @returns {*} Overrided directive definitions
 */
/** @ngInject */
let backTopDecorator = function backTopDecorator($delegate, $window) {
    $delegate.forEach(function(directiveDeffinition){
        directiveDeffinition.controller = function(){
            let $backTop = $('#backTop');
            $backTop.click(function(){
                $("html, body").stop().animate({scrollTop:0}, 500);
            }).css('position', 'fixed').addClass('animated').css('animation-duration', '0.25s');
            angular.element($window).on('scroll', function(e){
                if(angular.element($window).scrollTop() > $window.innerHeight/2){
                    $backTop
                        .removeClass('fadeOutRight')
                        .addClass('fadeInRight')
                        .css('display', 'block')
                } else {
                    $backTop
                        .removeClass('fadeInRight')
                        .addClass('fadeOutRight')
                }
            })
        };
    });
    return $delegate;
};

let backTopDecoratorConfig = function($provide) {
    /** @ngInject */

    $provide.decorator('backTopDirective', backTopDecorator);
};

export default angular.module('cms.blur-admin.backTopDecorator', ['BlurAdmin.theme.components'])
    .config(backTopDecoratorConfig).name;


// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/backTopDecorator/backTop.js